var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarNa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.87 94.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#007fc0;}.cls-2{fill:#00508c;}.cls-3{fill:#004682;}.cls-4{fill:#003c78;}.cls-5{fill:#c2afa1;}.cls-6{fill:#162b30;}.cls-7{fill:#17272d;}.cls-8{fill:#13262d;}.cls-9{fill:#0f1a1e;}.cls-10{fill:#1c333d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 47.43,
    cy: 47.43,
    r: 47.43
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.89,64.27H45V68.8H40.22s.85,26.06,6.38,26.06a51.37,51.37,0,0,0,16.13-2.58l3.2-18h0v0L60.3,71.6h0l-1.89-.9h0l-.36-.17-1.73-.82h0l-.88-.42h0l-1-.49H48.85l-.49-.67V64.27h2.22l11.5-5.52,3.81-18.34-1-17.27-8.71-5.66H37.51l-9,6.29-1,16.65,3.84,18.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "65.83 40.41 61.58 23.97 55.8 25.09 58.31 36.71 47.04 42.23 47.04 53.11 58.2 57.29 43.31 64.27 50.83 64.27 62.1 58.75 65.83 40.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "65.83 40.41 64.83 23.14 61.58 23.97 65.83 40.41 58.2 57.29 62.1 58.75 65.83 40.41 65.83 40.41 65.83 40.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "50.13 71.61 47.83 69.12 44.99 65.51 50.13 65.51 50.13 71.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 44.99,
    y: 64.27,
    width: 5.14,
    height: 1.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.68,93.5l-.06-1.77,3-3-.87-17L54.9,68.8H47.61V94.86A47.06,47.06,0,0,0,58.68,93.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36.8,93.66v-2l-2.91-2.93L34.64,75l-3.83,9.83,1.47,7.57C33.75,92.88,35.26,93.3,36.8,93.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.45,93.56c1.41-.34,2.8-.73,4.16-1.19l3.32-18.16L60.54,71.6l.83,17.21-2.92,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.92,93.9l-9.31-7.69v8.65A47.57,47.57,0,0,0,56.92,93.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M36.83,93.66v-2l-2.92-2.93L34.63,75l-3.82,9.78,1.47,7.57A45.58,45.58,0,0,0,36.83,93.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M58.48,93.55c1.49-.35,3-.78,4.38-1.27l3.07-18L60.54,71.6l.85,17.21-2.91,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58.68,93.5l-.06-1.79,3-2.94-.87-17L54.9,68.8l-7.29,6V89.21L56.35,94C57.13,93.86,57.91,93.69,58.68,93.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.66,75,33.6,88.76l2.83,2.9v1.91a47.45,47.45,0,0,0,11,1.29h.18V74.76l-7.39-6-11,5.34,1.62,10.68Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarNa);
export default __webpack_public_path__ + "static/media/avatar-na.3ce5add03527a252fc4873b3e4ae36a4.svg";
export { ForwardRef as ReactComponent };